import React from 'react';
import { Main } from './components';

export const Receive: React.FC = () => {
    return <Main />;
};

